//This code will run on all pages OTHER than the main page -
//It will set up the navigation menu and all of that stuff.

//This code will also run on news pages, when they are not in an iframe. 


if (window.self === window.top) {
    //We aren't embedded in news. 
    //Add the framing, favicon, etc

    //Add the favicon. 
    let sizes = [16,24,32,64,96,160,196]
    sizes.forEach((size) => {
        let favicon = document.createElement("link")
        favicon.rel = "shortcut icon"
        favicon.type = "image/png"
        favicon.sizes = size + "x" + size
        favicon.href = `/assets/icons/${size}x${size}-green-dragon.png`
        document.head.appendChild(favicon)
    })


    //Create branding container. 
    let brandingContainer = document.createElement("a")
    brandingContainer.href = "/"
    brandingContainer.classList.add("brandingContainer")

    let mahjongHeading = document.createElement("h1")
    mahjongHeading.innerText = "Mahjong"
    mahjongHeading.id = "mahjongHeading"
    brandingContainer.appendChild(mahjongHeading)

    let fourFriendsHeading = document.createElement("h1")
    fourFriendsHeading.innerText = "4 Friends"
    fourFriendsHeading.id = "fourFriendsHeading"
    brandingContainer.appendChild(fourFriendsHeading)




    //Create nav bar
    let topBar = document.createElement("nav")
    topBar.classList.add("topBar")


    //TODO: Make the navbar items dropdowns (so people can click directly on a specific news item or something). 
    function createItem(name, href) {
        let itemContainer = document.createElement("a")
        itemContainer.classList.add("topBarItem")
        itemContainer.href = href

        let item = document.createElement("div")
        item.innerText = name
        itemContainer.appendChild(item)

        topBar.appendChild(itemContainer)
        return itemContainer
    }

    let playButton = createItem("Play", "/")
    let newsButton = createItem("News", "/pages/news/")

    topBar.appendChild(brandingContainer)
    brandingContainer.classList.add("topBarItem")

    let FAQs = createItem("FAQs", "/pages/faqs/")

    let facebook = createItem("Facebook", "https://www.facebook.com/mahjong4friends")
    facebook.target = "_blank"

    document.documentElement.appendChild(topBar)

}














let css =`
body {
    padding: 8px;
}

.topBar {
	position: sticky;
	background-color: #111;
    border-left: 1px solid;
    border-right: 1px solid;
    border-color: #111;
    color: white;
	top: 0;
	left: 0;
	right: 0;
	z-index: 9999;
	width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 1.5em;
    box-sizing: border-box;
}

@media screen and (max-width: 600px) {
    .topBar {
        font-size: 1em;
    }
}

.topBarItem {
    width: 20%;
    text-align: center;
    padding: 10px 0px;
    cursor: pointer;
    color: white;
    text-decoration: none;
}

.topBarItem:hover {
    border-color: #888;
    background-color: #444;
}

.brandingContainer {
    font-size: 0.4em;
}

#mahjongHeading, #fourFriendsHeading {
	font-size: 2.5em;
	color: #ffbd17;
	display: inline-block;
	margin-top: 0.2em;
	margin-bottom: 0em;
}

#fourFriendsHeading {
	font-size: 2.1em;
	vertical-align: top;
	margin-left: 0.5em;
	font-style: italic;
	color: #ffe100;
}
`

let style = document.createElement("style")
style.innerHTML = css
document.documentElement.appendChild(style)



